import { apiEndpoints } from '@/apiEndpoints';
import { Client } from '@/types/clients/clientsColumnDef';
import { DistributorParams } from './distributor.api';
import axios from 'axios';
import { ClientFormData } from '@/types/clients/ClientFormData';
import { ClientResponse } from '@/types/clients/ClientResponse';

export type ClientsResponse = {
  clients: Client[];
  total: number;
  totalMine: number;
  agents: {
    id: string;
    firstname: string;
    lastname: string;
  }[];
};

export type ClientParams = DistributorParams & { onlyMine?: boolean };

export const findClients = async (options: ClientParams) => {
  const filtersStr = options.filters
    ? Object.entries(options.filters)
        .map(([key, value]) => `${key}:${encodeURIComponent(value)}`)
        .join(',')
    : undefined;
  const result = await axios.get<ClientsResponse>(apiEndpoints.clients.base, {
    params: { ...options, filters: filtersStr },
  });

  return result.data;
};

export type CreateClientDto = Omit<
  ClientFormData,
  'country' | 'reservationAgent' | 'postalCode'
> & {
  country?: string;
  reservationAgentId: string;
  postalCode?: string;
};

export const createClient = async (clientData: CreateClientDto) => {
  return axios.post(apiEndpoints.clients.base, clientData);
};

export const getClient = async (clientId: string) => {
  const result = await axios.get<{
    client: ClientResponse;
    countProjects: number;
  }>(apiEndpoints.clients.detail(clientId));
  return result.data;
};

type UpdateClientContactDto = Partial<CreateClientDto['mainContact']> & {
  id?: string;
};

export type UpdateClientDto = Partial<
  Omit<CreateClientDto, 'mainContact' | 'secondaryContacts'>
> & {
  mainContact?: UpdateClientContactDto;
  secondaryContacts: UpdateClientContactDto[];
};

export const updateClient = async (
  clientId: string,
  clientData: UpdateClientDto,
) => {
  return axios.put(apiEndpoints.clients.detail(clientId), clientData);
};

export const deleteClient = async (clientId: string) => {
  return axios.delete(apiEndpoints.clients.detail(clientId));
};

export const deleteMultipleClients = async (clientIds: string[]) => {
  return axios.delete(apiEndpoints.clients.multiple, {
    data: { clientIds },
  });
};
